import { render, staticRenderFns } from "./finuslugi-footer.vue?vue&type=template&id=290008d2&scoped=true"
import script from "./finuslugi-footer.vue?vue&type=script&lang=js"
export * from "./finuslugi-footer.vue?vue&type=script&lang=js"
import style0 from "./finuslugi-footer.vue?vue&type=style&index=0&id=290008d2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290008d2",
  null
  
)

export default component.exports